import { authenticatedAPI } from '../AuthenticatedAPI';
import {
  batchNewVouchersCreationResultDto,
  BatchOfNewVouchersReqDto,
  voucherLevelsResDto,
} from '@web/common';

export const batchCreateVouchers = async (
  vouchers: BatchOfNewVouchersReqDto,
) => {
  return authenticatedAPI.post(
    `api/voucher/insert-batch`,
    vouchers,
    batchNewVouchersCreationResultDto,
  );
};
export const voucherLevels = async () => {
  return authenticatedAPI.get(`api/voucher/levels`, voucherLevelsResDto);
};
